import {CustomCode} from "./custom.code";
import {schemaOf} from "@rezonence/schema-transformer";


export const customCodeSchema = schemaOf<CustomCode>();
